import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { UserService } from "./user.service";

@Injectable({
  providedIn: 'root'
})
export class ScopeService {
  constructor(private http: HttpClient, private userService: UserService) { }

  getAppAreas(parms?: any) {
    const url = `/api/${this.userService.customer}/appareas?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, parms);
  }
  updateAppArea(item: any) {
    const url = `/api/${this.userService.customer}/appareas/${item.id}?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, item);
  }
  deleteAppArea(item: any) {
    const url = `/api/${this.userService.customer}/appareas/${item.id}?apiKey=${this.userService.apiKey}`;
    return this.http.delete(url, item);
  }

  getLibraries(parms?: any) {
    const url = `/api/${this.userService.customer}/libraries?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, parms);
  }

  updateLibrary(item: any) {
    const url = `/api/${this.userService.customer}/libraries/${encodeURIComponent(item.name)}?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, item);
  }

  massUpdateLibraries(parms?: any) {
    const url = `/api/${this.userService.customer}/libraries?apiKey=${this.userService.apiKey}`;
    return this.http.patch(url, parms);
  }

  getObjects(parms?: any) {
    const url = `/api/${this.userService.customer}/objects?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, parms);
  }

  updateObject(item: any) {
    const url = `/api/${this.userService.customer}/objects/${item.id}?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, item);
  }

  massUpdateObjects(parms?: any) {
    const url = `/api/${this.userService.customer}/Objects?apiKey=${this.userService.apiKey}`;
    return this.http.patch(url, parms);
  }

  getScopePhases(parms?: any) {
    const url = `/api/${this.userService.customer}/getScopePhaseData?apiKey=${this.userService.apiKey}`;
    return this.http.patch(url, parms);
  }

  getEntryPoints(parms?: any) {
    const url = `/api/${this.userService.customer}/navigations?apiKey=${this.userService.apiKey}`;
    return this.http.post(url, parms);
  }
}
